module.exports = __webpack_public_path__ + "static/media/lightning.dcc53c17.svg";